'use strict';

var index = require('../../../../../../../prop-types/index.cjs');

const responsivePropType = process.env.NODE_ENV !== 'production' ? index.oneOfType([index.number, index.string, index.object, index.array]) : {};

module.exports = responsivePropType;
//# sourceMappingURL=responsivePropType.cjs.map
